module.exports = __webpack_public_path__ + "static/img/bg2.27b57917.png";